import { Layout } from 'antd'
import * as React from 'react'
import { Trigger } from '../../components'
import * as styles from './CollapsibleSidebar.module.less'

const { Sider } = Layout

export interface CollapsibleSidebarProps {
    collapsed: boolean
    collapsibleSidebar?: React.ReactNode
}

export const CollapsibleSidebar: React.FC<CollapsibleSidebarProps> = (
    props
) => {
    const { collapsed, collapsibleSidebar } = props

    return (
        <Sider
            trigger={null}
            collapsible
            collapsed={collapsed}
            collapsedWidth={20}
            className={`${styles.collapsibleSidebar} collapsibleSidebar`}
            width={'unset'}
            style={{ padding: collapsed ? 0 : '12px' }}
            theme="light"
        >
            <div style={{ visibility: collapsed ? 'hidden' : 'visible' }}>
                {collapsibleSidebar}
            </div>
            <div className={`${styles.triggerContainer} triggerContainer`}>
                <Trigger />
            </div>
        </Sider>
    )
}
